import { createSlice } from '@reduxjs/toolkit';
import { UserResponseData } from '../models/BrandlistResponse';

export interface stateTypes {
  userOptions: UserResponseData[],
  brandNameOptions: string[]
}

const initialState: stateTypes = {
  userOptions: [],
  brandNameOptions: []
};

const optionSlice = createSlice({
    name: 'options',
    initialState,
    reducers: {
      saveUserOptions (state, action) {
        return {...state, userOptions: action.payload}
      },
      saveBrandOptions (state, action) {
        return {...state, brandNameOptions: action.payload}
      }
    }
})

export const {saveUserOptions, saveBrandOptions} = optionSlice.actions;

export default optionSlice.reducer;